import { z } from 'zod';

/**
 * Link preview ("read-later" unfurl). The client asks the server to unfurl a
 * URL it found in a message; the server fetches it (SSRF-guarded), parses the
 * OpenGraph/meta tags, caches the result, and returns this shape. The client
 * never fetches arbitrary pages itself — it only ever talks to our endpoint.
 */
export const unfurlQuerySchema = z.object({
  url: z.string().url().max(2048),
  // Optional channel the link appears in. When it's a guild channel, the
  // server checks the caller's EMBED_LINKS permission there before fetching:
  // deny EMBED_LINKS on @everyone → no preview cards render in that channel.
  // Absent (or a DM/self channel) → no permission gate.
  channelId: z.string().cuid().optional(),
});
export type UnfurlQuery = z.infer<typeof unfurlQuerySchema>;

export const linkPreviewSchema = z.object({
  /** The URL that was unfurled (the canonical/normalised form the server used). */
  url: z.string().url(),
  title: z.string().nullable(),
  description: z.string().nullable(),
  /** Absolute image URL (resolved against the page), or null when none. */
  imageUrl: z.string().url().nullable(),
  /** Site name (og:site_name) or the bare host as a fallback. */
  siteName: z.string().nullable(),
});
export type LinkPreview = z.infer<typeof linkPreviewSchema>;
